<div [fxHide]="Spinner.isShown('initForms')" class="w-100" fxLayout="column" fxLayoutAlign="start start">
    @if (contactForm) {
        <form [formGroup]="contactForm" fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-16">
            <div class="grid-form-container">
                <af-dictionary-selector [dictionaryName]="ReferenceBookType.CONTACT_TYPE"
                                        [control]="contactForm.controls.contactType"
                                        [shouldSortDictionary]="true"
                                        label="i18n_af_labelContactType"
                                        placeholder="i18n_af_placeholderContactType"/>

                @for (section of activeTypeSections; track section.controlName) {
                    <af-dictionary-selector [dictionaryName]="section.dictionaryName"
                                            [control]="getControl(section.controlName)"
                                            [label]="section.label"
                                            [placeholder]="section.placeholder"/>

                    @if (getControl(section.controlName)?.value === OTHER_VALUE) {
                        <ng-container *ngTemplateOutlet="otherInput; context: {
                            control: getControl(section.otherControlName),
                            label: section.otherLabel,
                            placeholder: section.otherPlaceholder,
                            formControlName: section.otherControlName,
                            showRequired: true
                        }"/>
                    }
                }
            </div>

            @if (contactForm.controls.contactType?.value) {
                @if (contactForm.controls.contactType?.value === 'MESSENGER') {
                    <div class="grid-form-container mt-24">
                        <af-dictionary-selector [dictionaryName]="ReferenceBookType.MESSENGER_CONTACT_TYPE"
                                                [control]="contactForm.controls.messengerContactType"
                                                label="i18n_af_labelMessengerType"
                                                placeholder="i18n_af_placeholderMessengerType"/>

                        @if (contactForm.controls.messengerContactType?.value === OTHER_VALUE) {
                            <ng-container *ngTemplateOutlet="otherInput; context: {
                                control: contactForm.controls.messengerContactTypeOther,
                                label: 'i18n_af_labelMessengerTypeOther',
                                placeholder: 'i18n_af_placeholderMessengerTypeOther',
                                formControlName: 'messengerContactTypeOther',
                                showRequired: false
                            }"/>
                        }
                    </div>

                    <ng-container *ngTemplateOutlet="fraudsterRoleBlock"/>
                }

                @if (CONTACT_TYPES_WITH_MSISDN.includes(contactForm.controls.contactType?.value)) {
                    <div class="grid-form-container mt-24">
                        <af-phone-number class="w-100"
                                         widthClass="w-100"
                                         [control]="contactForm.controls.msisdn"
                                         [selectedPhoneInfoControl]="contactForm.controls.selectedMsisdnInfo"
                                         [predefinedValue]="msisdnPredefinedValue"
                                         [readOnly]="msisdnReadOnly"
                                         label="i18n_af_labelFraudsterMsisdn"/>

                        <ng-container *ngTemplateOutlet="datePickerField; context: {
                            labelKey: 'i18n_af_labelContactDate',
                            placeholderKey: 'i18n_af_placeholderContactDate',
                            form: contactForm.controls.contactDateTime
                        }"/>
                    </div>
                }

                <div class="grid-form-container mt-24">
                    <af-dictionary-selector [dictionaryName]="ReferenceBookType.CONTACT_TIMEFRAME"
                                            [control]="contactForm.controls.contactTimeframe"
                                            label="i18n_af_labelContactTimeframe"
                                            placeholder="i18n_af_placeholderContactTimeframe"/>

                    <af-dictionary-selector [dictionaryName]="ReferenceBookType.CONTACT_REASON"
                                            [control]="contactForm.controls.contactReason"
                                            label="i18n_af_labelContactReason"
                                            placeholder="i18n_af_placeholderContactReason"/>
                </div>

                @if (contactForm.controls.contactReason?.value === OTHER_VALUE) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-24">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelContactReasonOther' | translate }}</div>
                        <mat-form-field class="mt-4 w-100"
                                        [class.value-not-empty]="contactForm.controls.contactReasonOther?.value">
                            <textarea matInput
                                      #contactReasonOtherArea
                                      [maxlength]="CONTACT_REASON_OTHER_MAX_LENGTH"
                                      class="resize-none pt-12 pb-12"
                                      [placeholder]="'i18n_af_placeholderContactReasonOther' | translate"
                                      formControlName="contactReasonOther"></textarea>
                            <mat-hint align="start" class="t5 c-primary-gray-600">
                                {{ contactReasonOtherArea.value?.length || 0 }} / {{ CONTACT_REASON_OTHER_MAX_LENGTH }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                }

                <div class="grid-form-container mt-24">
                    <af-dictionary-selector [dictionaryName]="ReferenceBookType.VICTIM_ACTION"
                                            [control]="contactForm.controls.victimActions"
                                            [isMultiple]="true"
                                            [shouldAlwaysShowSelectedCount]="true"
                                            selectedCountPlaceholder="i18n_af_placeholderSelectedCount"
                                            label="i18n_af_labelVictimAction"
                                            placeholder="i18n_af_placeholderVictimAction"/>

                    @if (CONTACT_TYPES_WITH_INLINE_FRAUDSTER_ROLE.includes(contactForm.controls.contactType?.value)) {
                        <af-dictionary-selector [dictionaryName]="ReferenceBookType.FRAUDSTER_ROLE"
                                                [control]="contactForm.controls.fraudsterRole"
                                                label="i18n_af_labelFraudsterRole"
                                                placeholder="i18n_af_placeholderFraudsterRole"/>
                    } @else if (contactForm.controls.contactType?.value === 'MESSENGER') {
                        <ng-container *ngTemplateOutlet="datePickerField; context: {
                            labelKey: 'i18n_af_labelVictimAppealDate',
                            placeholderKey: 'i18n_af_placeholderVictimAppealDate',
                            form: contactForm.controls.victimAppealDateTime
                        }"/>
                    } @else {
                        <ng-container *ngTemplateOutlet="datePickerField; context: {
                            labelKey: 'i18n_af_labelContactDate',
                            placeholderKey: 'i18n_af_placeholderContactDate',
                            form: contactForm.controls.contactDateTime
                        }"/>
                    }
                </div>

                @if (contactForm.controls.victimActions?.value?.includes(OTHER_VALUE)) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-24">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelVictimActionOther' | translate }}</div>
                        <mat-form-field class="mt-4 w-100"
                                        [class.value-not-empty]="contactForm.controls.victimActionOther?.value">
                            <textarea matInput
                                      #victimActionOtherArea
                                      [maxlength]="VICTIM_ACTION_OTHER_MAX_LENGTH"
                                      class="resize-none pt-12 pb-12"
                                      [placeholder]="'i18n_af_placeholderVictimActionOther' | translate"
                                      formControlName="victimActionOther"></textarea>
                            <mat-hint align="start" class="t5 c-primary-gray-600">
                                {{ victimActionOtherArea.value?.length || 0 }} / {{ VICTIM_ACTION_OTHER_MAX_LENGTH }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                }

                @if (!CONTACT_TYPES_WITH_MSISDN.includes(contactForm.controls.contactType?.value)) {
                    <ng-container *ngTemplateOutlet="fraudsterRoleBlock"/>
                }

                @if (CONTACT_TYPES_WITH_INLINE_FRAUDSTER_ROLE.includes(contactForm.controls.contactType?.value) && contactForm.controls.fraudsterRole?.value === OTHER_VALUE) {
                    <div class="grid-form-container mt-24">
                        <ng-container *ngTemplateOutlet="otherInput; context: {
                            control: contactForm.controls.fraudsterRoleOther,
                            label: 'i18n_af_labelFraudsterRoleOther',
                            placeholder: 'i18n_af_placeholderFraudsterRoleOther',
                            formControlName: 'fraudsterRoleOther',
                            showRequired: false
                        }"/>
                    </div>
                }

                <div class="grid-form-container mt-24">
                    <ng-container *ngTemplateOutlet="ipPortField; context: {
                        label: 'i18n_af_labelIpPortFrom',
                        ipControl: contactForm.controls.ipFrom,
                        portControl: contactForm.controls.portFrom,
                        ipName: 'ipFrom',
                        portName: 'portFrom'
                    }"/>

                    <ng-container *ngTemplateOutlet="ipPortField; context: {
                        label: 'i18n_af_labelIpPortTo',
                        ipControl: contactForm.controls.ipTo,
                        portControl: contactForm.controls.portTo,
                        ipName: 'ipTo',
                        portName: 'portTo'
                    }"/>
                </div>

                @if (contactForm.controls.contactType?.value !== 'MESSENGER') {
                    <div class="grid-form-container mt-24">
                        <ng-container *ngTemplateOutlet="datePickerField; context: {
                            labelKey: 'i18n_af_labelVictimAppealDate',
                            placeholderKey: 'i18n_af_placeholderVictimAppealDate',
                            form: contactForm.controls.victimAppealDateTime
                        }"/>
                    </div>
                }

                @if (showDetailsTextarea) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-24">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelContactDetails' | translate }}</div>
                        <mat-form-field class="mt-4 w-100"
                                        [class.value-not-empty]="contactForm.controls.details?.value">
                            <textarea matInput
                                      #detailsArea
                                      [maxlength]="DETAILS_MAX_LENGTH"
                                      class="resize-none pt-12 pb-12"
                                      [placeholder]="'i18n_af_placeholderContactDetails' | translate"
                                      formControlName="details"></textarea>
                            <mat-hint align="start" class="t5 c-primary-gray-600">
                                {{ detailsArea.value?.length || 0 }} / {{ DETAILS_MAX_LENGTH }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                }

                @if (contactForm.controls.attachments) {
                    <af-files
                        class="w-824 mt-40"
                        label="i18n_af_labelAdditionalFiles"
                        [excludeItemsWithCode1]="true"
                        [form]="contactForm.controls.attachments"
                        [attachments]="existingAttachments"
                        [bucket]="BucketName.CONTACT_DETAILS_FILES"/>
                }

                @if (CONTACT_TYPES_WITH_SUSPICIOUS_LINKS.includes(contactForm.controls.contactType?.value)) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-40">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                            <div class="t2-semi-bold c-primary-gray-900">{{ 'i18n_af_labelSuspiciousLinks' | translate }}</div>
                            <ui-kit-button type="text"
                                           iconPosition="left"
                                           icon="ic_add_circle"
                                           [disabled]="!canAddMoreLinks"
                                           [matTooltip]="'i18n_af_hintMaxLinks' | translate: {count: MAX_LINKS}"
                                           [matTooltipDisabled]="canAddMoreLinks"
                                           (clickListener)="addLinkListener.emit()"
                                           [label]="'i18n_af_buttonAddLink' | translate"/>
                        </div>
                        <div formArrayName="suspiciousLinks" class="w-100">
                            @for (linkControl of contactForm.controls.suspiciousLinks.controls; track linkControl; let i = $index) {
                                <div fxLayout="row" fxLayoutAlign="start center" class="w-100 mt-16">
                                    <div fxLayout="column" fxLayoutAlign="start start" fxFlex>
                                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelSuspiciousLink' | translate }}</div>
                                        <mat-form-field class="w-100 mt-4"
                                                        [class.value-not-empty]="linkControl.value && linkControl.value !== 'https://'">
                                            <input matInput
                                                   [formControlName]="i"
                                                   placeholder="https://"
                                                   name="suspiciousLink"/>
                                            @if (linkControl.hasError('required')) {
                                                <mat-error class="c-secondary-red-900">
                                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                                </mat-error>
                                            } @else if (linkControl.hasError('invalidUrl')) {
                                                <mat-error class="c-secondary-red-900">
                                                    {{ 'i18n_af_fieldValidationInvalidUrl' | translate }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    @if (canRemoveLink) {
                                        <ui-kit-svg
                                            class="i-24 ml-8 pointer c-secondary-red-900"
                                            name="ic_delete"
                                            (click)="removeLinkListener.emit(i)"/>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        </form>
    }
    @if (showAddContactButton) {
        <ui-kit-button
            type="text"
            class="mt-24"
            fxFlexAlign="start"
            iconPosition="left"
            [disabled]="isAddContactButtonDisabled"
            [label]="'i18n_af_buttonAddContact' | translate"
            icon="ic_add_circle"
            (clickListener)="addNewContactListener.emit()"/>
    }
</div>

<ng-template #otherInput let-control="control" let-label="label" let-placeholder="placeholder"
             let-formControlName="formControlName" let-showRequired="showRequired">
    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
        <div class="t5 c-primary-gray-600">
            {{ label | translate }}
            {{ showRequired && control?.hasValidator(Validators.required) ? '*' : '' }}
        </div>
        <mat-form-field class="w-100 mt-4"
                        [class.value-not-empty]="control?.value">
            <input matInput
                   [formControl]="control"
                   [maxlength]="OTHER_FIELD_MAX_LENGTH"
                   [placeholder]="placeholder | translate"
                   [name]="formControlName"/>
            @if (control?.hasError('required')) {
                <mat-error class="c-secondary-red-900">
                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                </mat-error>
            }
        </mat-form-field>
    </div>
</ng-template>

<ng-template #ipPortField let-label="label" let-ipControl="ipControl"
             let-portControl="portControl" let-ipName="ipName" let-portName="portName">
    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
        <div class="t5 c-primary-gray-600">{{ label | translate }}</div>
        <div fxLayout="row" fxLayoutAlign="start start" class="w-100 mt-4">
            <af-ip-input class="ip-field"
                         [control]="ipControl"
                         [name]="ipName"/>
            <span class="ml-8 mr-8 ip-port-separator">:</span>
            <mat-form-field class="port-field"
                            [class.value-not-empty]="portControl?.value">
                <input matInput
                       mask="00000"
                       [validation]="false"
                       [formControl]="portControl"
                       [placeholder]="'port'"
                       [name]="portName"/>
            </mat-form-field>
        </div>
    </div>
</ng-template>

<ng-template #datePickerField let-labelKey="labelKey" let-placeholderKey="placeholderKey"
             let-form="form">
    <af-date-picker-field [labelTranslationKey]="labelKey"
                          [placeholderTranslationKey]="placeholderKey"
                          displayFormat="DD.MM.YYYY HH:MM"
                          [form]="form"
                          [showPickerActions]="true"
                          [supportedDateFormat]="['DDMMYYYYHHMM', 'DD.MM.YYYY HH:MM']"
                          [dateFormats]="DATE_TIME_FORMATS"/>
</ng-template>

<ng-template #fraudsterRoleBlock>
    <div class="grid-form-container mt-24">
        <af-dictionary-selector [dictionaryName]="ReferenceBookType.FRAUDSTER_ROLE"
                                [control]="contactForm.controls.fraudsterRole"
                                label="i18n_af_labelFraudsterRole"
                                placeholder="i18n_af_placeholderFraudsterRole"/>

        @if (contactForm.controls.fraudsterRole?.value === OTHER_VALUE) {
            <ng-container *ngTemplateOutlet="otherInput; context: {
                control: contactForm.controls.fraudsterRoleOther,
                label: 'i18n_af_labelFraudsterRoleOther',
                placeholder: 'i18n_af_placeholderFraudsterRoleOther',
                formControlName: 'fraudsterRoleOther',
                showRequired: false
            }"/>
        }
    </div>
</ng-template>
